import "./common";
import { AnalysisTool } from "./shim";

/**
 * Delegate overrides to JavaScript tool.
 */
AnalysisTool.delegate = {
  extractFrameUrl: (_mediaId: string, _captureTime: number) => "",
  saveImage: (
    base64: string,
    complete: (data: string | HTMLImageElement | null) => void
  ) => {
    complete(base64);
  },
  mediaInfo: (
    mediaID: string,
    callback: (data: { fps?: number; width: number; height: number }) => void
  ) => {}
};
